import styled from 'styled-components'

export default styled.section`
  max-width: 800px;
  width: 100%;
  margin: 50px auto;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;

  .spinner-container {
    display: flex;
    justify-content: center;
    padding: 48px 0;
  }

  > h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${ ({ theme }) => theme.colors.greyDark };
  }

  .progress {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .track {
      display: flex;
      flex-direction: row;
      gap: 4px;

      .step {
        flex: 1;
        height: 8px;
        border-radius: 4px;
        background-color: ${ ({ theme }) => theme.colors.greyLight };
        transition: background-color 0.2s ease-in;
      }
    }

    .faces {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .message {
    padding: 20px 24px;
    border-radius: 12px;
    /* the page ground is almostWhite, so the card needs to be plain white to read as one */
    background-color: ${ ({ theme }) => theme.colors.white };
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    gap: 6px;

    .title {
      font-size: 20px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .subtitle {
      margin: 0;
      color: ${ ({ theme }) => theme.colors.black };
    }

    .end-date {
      margin: 0;
      font-weight: 700;
      color: ${ ({ theme }) => theme.colors.red };
    }
  }

  .penalties-list {
    display: flex;
    flex-direction: column;
    background-color: ${ ({ theme }) => theme.colors.white };
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
`
